import { lazyMinLoadTime } from './LazyFallback';

export const routeComponents = {
  Deposit: lazyMinLoadTime(() => import('#/pages/deposit/Deposit'), 0),
  Withdrawal: lazyMinLoadTime(() => import('#/pages/withdrawal/Withdrawal'), 0),
  page404: lazyMinLoadTime(() => import('#/pages/page404/page404'), 0),
};
